<template>
  <v-container>
    <v-row>
      <p class="text-h4">Contact info</p>
    </v-row>
    <v-row>
      <v-col
          class="px-0 px-md-2 pl-md-0"
          cols="12"
          md="6"
      >
        <v-text-field
            v-model="firstname.value"
            :rules="firstname.rules"
            :append-inner-icon="isEditing ? null : 'mdi-lock'"
            :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
            :disabled="!isEditing || isLoading"
            :loading="isLoading"
            label="First name"
        />
      </v-col>

      <v-col class="px-0 px-md-2 pr-md-0" cols="12" md="6">
        <v-text-field
            v-model="lastname.value"
            :rules="lastname.rules"
            :append-inner-icon="isEditing ? null : 'mdi-lock'"
            :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
            :disabled="!isEditing || isLoading"
            :loading="isLoading"
            label="Last name"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
          class="px-0 px-md-2 pl-md-0"
          cols="12"
          md="6"
      >
        <v-text-field
            :model-value="email"
            :loading="isLoading"
            :disabled="true"
            label="Email"
            append-inner-icon="mdi-lock"
            bg-color="grey-lighten-1"
        />
      </v-col>
      <v-col
          class="px-0 px-md-2 pr-md-0"
          cols="12"
          md="6"
      >
        <v-text-field
            v-model="phone.value"
            :rules="phone.rules"
            :append-inner-icon="isEditing ? null : 'mdi-lock'"
            :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
            :disabled="!isEditing || isLoading"
            :loading="isLoading"
            label="Phone"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-text-field
          v-model="address.value"
          :rules="address.rules"
          :append-inner-icon="isEditing ? null : 'mdi-lock'"
          :bg-color="isEditing ? 'grey-lighten-3' : 'grey-lighten-1'"
          :disabled="!isEditing || isLoading"
          :loading="isLoading"
          label="Address"
      />
    </v-row>
    <v-row class="mb-3">
      <v-spacer/>
      <v-col
          cols="auto"
          class="pt-0"
      >
        <v-btn
            v-if="isEditing"
            :disabled="isLoading"
            color="grey-lighten-3"
            @click="cancelEditing"
        >
          Cancel
        </v-btn>
      </v-col>
      <v-col
          cols="auto"
          class="pr-0 pt-0"
      >
        <v-btn
            :text="isEditing ? 'Save contact info' : 'Change contacts'"
            :block="true"
            :disabled="isLoading"
            color="success"
            @click="changeClick"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ProfileContactInfoCard",
  emits: ['switchEditState', 'submitProfile'],
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    initFirstname: String,
    initLastname: String,
    email: String,
    initPhone: String,
    initAddress: String
  },
  watch: {
    initFirstname(value) {
      this.firstname.value = value
    },
    initLastname(value) {
      this.lastname.value = value
    },
    initPhone(value) {
      this.phone.value = value
    },
    initAddress(value) {
      this.address.value = value
    }
  },
  data() {
    return {
      firstname: {
        value: this.initFirstname,
        rules: [
          v => !!v || 'Firstname is required',
          v => v.length > 2 && v.length < 60 || 'Invalid firstname'
        ]
      },
      lastname: {
        value: this.initFirstname,
        rules: [
          v => !!v || 'Lastname is required',
          v => v.length > 2 && v.length < 60 || 'Invalid lastname'
        ]
      },
      phone: {
        value: this.initPhone,
        rules: [
          v => !!v || 'Phone is required',
          v => v.length > 6 && v.length < 50 || 'Invalid phone'
        ]
      },
      address: {
        value: this.initAddress,
        rules: [
          v => !!v || 'Address is required',
          v => v.length > 3 && v.length < 40 || 'Invalid address'
        ]
      },
    }
  },
  methods: {
    changeClick() {
      if (this.isEditing) {
        this.submitProfile()
      } else {
        this.edit()
      }
    },
    edit() {
      this.$emit('switchEditState')
    },
    cancelEditing() {
      this.$emit('switchEditState')
      this.firstname = this.initFirstname
      this.lastname = this.initLastname
      this.phone = this.initPhone
      this.address = this.initAddress
    },
    submitProfile() {
      this.$emit('submitProfile', {
        firstname: this.firstname.value,
        lastname: this.lastname.value,
        phone: this.phone.value,
        address: this.address.value
      })
    }
  }
}
</script>

<style scoped>

</style>